<ion-content
  class="form-content"
  *ngIf="authServ.isLogged || menuItem.profile_is_not_required; else noLogged"
>
  <ion-header>
    <ion-toolbar mode="ios" color="primary">
      <ion-button
        (click)="close()"
        fill="clear"
        color="white"
        class="ion-no-padding"
      >
        <ion-icon slot="icon-only" name="chevron-back"></ion-icon>
      </ion-button>
      <ion-title class="ion-no-padding">
        <ion-text [color]="'white'" class="ion-text-center">
          <h1>{{ menuItem.name | caption }}</h1>
        </ion-text>
      </ion-title>
    </ion-toolbar>
  </ion-header>

  <ion-grid class="form">
    <!-- Date Area Start -->
    <div class="order__heading">
      <ion-label>{{ "Select Date" | translate }}</ion-label>
    </div>

    <ion-row class="date__pick__area">
      <ion-col size="12" class="date__buttons">
        <ng-container *ngFor="let orderDate of orderDates; let i = index">
          <ion-col
            size="1.8"
            class="date__button"
            [ngClass]="{
              'selected-radio': selectedDate?.date === orderDate.date,
              'disabled-radio': !orderDate.times,
              bordered: i === 0
            }"
          >
            <label [htmlFor]="orderDate.date">
              <p class="date__day">
                {{ orderDate.day | slice : 0 : 3 | translate }}
              </p>
              <p class="date__number">{{ orderDate.date.split("/")[2] }}</p>
            </label>
            <input
              [disabled]="orderDate.times === null"
              type="radio"
              [id]="orderDate.date"
              [(ngModel)]="selectedDate"
              [value]="orderDate"
              style="display: none"
            />
          </ion-col>
        </ng-container>
      </ion-col>
    </ion-row>

    <div class="order__heading">
      <ion-label>{{ "Select Time" | translate }}</ion-label>
    </div>
    <ion-row class="hour__choice__area">
      <ion-col size="12" class="ion-no-padding">
        <ion-row class="hour__choices">
          <ion-col
            size="4"
            *ngFor="let time of selectedDate?.times"
            [ngClass]="{
              hour__button: true,
              'selected-radio': timeOfOrder === time
            }"
          >
            <label [htmlFor]="time">
              <p class="hour__time">{{ time }}</p>
            </label>
            <input
              type="radio"
              [id]="time"
              [(ngModel)]="timeOfOrder"
              [value]="time"
              style="display: none"
            />
          </ion-col>
        </ion-row>
      </ion-col>
    </ion-row>
    <!-- Date Area End -->
  </ion-grid>
</ion-content>

<ion-footer *ngIf="timeOfOrder">
  <ion-row class="cart__summary">
    <ion-col size="12" class="summary__item__name"
      ><ion-text color="primary">{{
        menuItem.name | caption
      }}</ion-text></ion-col
    >
    <ion-col size="12">
      <ion-list>
        <div style="max-height: 16vh; overflow-y: scroll">
          <ng-container *ngFor="let item of cartServ.cart">
            <div class="cart__summary__item">
              <ion-label>
                <span
                  class="Montserrat item__product__name"
                  [innerHTML]="
                    item.product.name | caption | translate | slice : 0 : 15
                  "
                ></span>
                <span
                  class="item__product__name"
                  *ngIf="(item.product.name | caption | translate)?.length > 12"
                  >...</span
                >

                <ng-container *ngIf="item.size.size | caption | translate">
                  (<span
                    class="Montserrat item__product__name"
                    [innerHTML]="item.size.size | caption | translate"
                  ></span
                  >)
                </ng-container>

                <ion-text
                  color="dark"
                  class="ion-float-right"
                  style="display: flex"
                >
                  <ion-buttons
                    style="display: flex; margin-right: 2vw"
                    *ngIf="
                      dataServ.menuItem.order_system && dataServ.requestActive
                    "
                  >
                    <ion-button
                      appEqualWidthHeight
                      equalWith="height"
                      [disabled]="item.size.quantity === 0"
                      fill="solid"
                      color="primary"
                      class="ion-no-padding add__remove__button"
                      (click)="
                        analytic(findCatalogById(item), item.size, 'remove');
                        item.size.quantity = item.size.quantity - 1;
                        cartUpdate(findCatalogById(item), item.size)
                      "
                    >
                      <ion-icon slot="icon-only" name="remove"></ion-icon>
                    </ion-button>

                    <ion-text
                      style="width: 40px; text-align: center; color: #a1a1a1"
                    >
                      {{ item.size.quantity }}
                    </ion-text>

                    <ion-button
                      appEqualWidthHeight
                      equalWith="height"
                      fill="solid"
                      color="primary"
                      class="ion-no-padding add__remove__button"
                      (click)="
                        analytic(findCatalogById(item), item.size, 'add');
                        item.size.quantity = item.size.quantity + 1;
                        cartUpdate(findCatalogById(item), item.size)
                      "
                    >
                      <ion-icon
                        color="white"
                        slot="icon-only"
                        name="add"
                      ></ion-icon>
                    </ion-button>
                  </ion-buttons>

                  <ng-container
                    *ngIf="item.size.currency_code === 'TL'; else otherLang"
                  >
                    <ion-text class="item__price__text">
                      <b class="item__price"
                        ><small
                          >({{ item.amount | customCurrency }}
                          {{ item.size.currency_code }})</small
                        ></b
                      >
                    </ion-text>
                  </ng-container>
                  <ng-template #otherLang>
                    <ion-text class="item__price__text">
                      <b class="item__price"
                        ><small
                          >({{ item.size.currency_code
                          }}{{ item.amount | customCurrency }})</small
                        ></b
                      >
                    </ion-text>
                  </ng-template>
                </ion-text>
              </ion-label>
            </div>
          </ng-container>

          <div
            class="cart__summary__item"
            style="border-top: 2px solid lightgray"
            *ngIf="
              cartServ.cart.length > 0 &&
              cartServ.totalAmount < menuItem.free_service_over_amount &&
                !(cartServ.totalAmount === 0)
            "
          >
            <ion-label
              class="Montserrat"
              style="font-size: 85%; color: #656565"
            >
              {{ "Service Charge" | translate }}
              <ion-text color="primary" class="ion-float-right">
                <!-- Fixed (0) -->
                <ng-container
                  *ngIf="menuItem.service_charge_type === 0; else percentCharge"
                >
                  <ng-container
                    *ngIf="
                      menuItem.service_charge_currency_code === 'TL';
                      else currencyFirst
                    "
                  >
                    <b
                      >{{ menuItem.service_charge | customCurrency }}
                      {{ menuItem.service_charge_currency_code }}</b
                    >
                  </ng-container>
                  <ng-template #currencyFirst>
                    <ion-text color="primary">
                      <b
                        >{{ menuItem.service_charge_currency_code
                        }}{{ menuItem.service_charge | customCurrency }}</b
                      >
                    </ion-text>
                  </ng-template>
                </ng-container>
                <!-- Percentage (1) -->
                <ng-template #percentCharge>
                  <ng-container>
                    <b>
                      %{{ menuItem.service_charge }}
                      (
                      {{
                        cartServ.totalAmount * (menuItem.service_charge / 100)
                          | customCurrency
                      }}
                      {{ menuItem.service_charge_currency_code }}
                      )
                    </b>
                  </ng-container>
                </ng-template>
              </ion-text>
            </ion-label>
          </div>
        </div>

        <div class="cart__summary__item" style="border: none">
          <ion-label color="dark"
            >{{ "Total" | translate }}
            <ion-text
              class="total__amount"
              color="primary"
              class="ion-float-right"
            >
              <ng-container
                *ngIf="cartServ.currencyCode === 'TL'; else otherLang"
              >
                <b>
                  {{
                    cartServ.totalAmount +
                      (cartServ.totalAmount <
                        menuItem.free_service_over_amount &&
                      cartServ.totalAmount !== 0
                        ? menuItem.service_charge_type === 0
                          ? menuItem.service_charge
                          : (cartServ.totalAmount * menuItem.service_charge) /
                            100
                        : 0) | customCurrency
                  }}
                  {{ cartServ.currencyCode }}
                </b>
              </ng-container>
              <ng-template #otherLang>
                <ion-text class="total__amount" color="primary">
                  <b>
                    {{ cartServ.currencyCode }}
                    {{
                      cartServ.totalAmount +
                        (cartServ.totalAmount <
                          menuItem.free_service_over_amount &&
                        cartServ.totalAmount !== 0
                          ? menuItem.service_charge_type === 0
                            ? menuItem.service_charge
                            : (cartServ.totalAmount * menuItem.service_charge) /
                              100
                          : 0) | customCurrency
                    }}
                  </b>
                </ion-text>
              </ng-template>
            </ion-text>
          </ion-label>
        </div>

        <ion-button
          *ngIf="!timeOfOrder || cartServ.totalAmount === 0; else realButton"
          (click)="showToaster()"
          expand="block"
          color="primary"
          >{{ "Next" | translate }}</ion-button
        >

        <ng-template #realButton>
          <ion-button (click)="next()" expand="block" color="primary">{{
            "Next" | translate
          }}</ion-button>
        </ng-template>
      </ion-list>
    </ion-col>
  </ion-row>
</ion-footer>

<ng-template #noLogged>
  <ion-button
    (click)="close()"
    fill="clear"
    color="light"
    class="ion-no-padding login-back"
  >
    <ion-icon slot="icon-only" name="chevron-back"></ion-icon>
  </ion-button>
  <app-profile></app-profile>
</ng-template>
